var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foodmash-card foodmash-default foodmash-deck-empty"},[_c('div',{staticClass:"foodmash-frame"},[_c('span',[_vm._v(_vm._s(_vm.messageToShow))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f658c200","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/FoodmashDeckEmpty.vue
// module id = rGq6
// module chunks = 1